import { atom } from 'jotai'

import type { FetchVehicleDispatchBoardsQuery } from '../../api/fetch-vehicle-dispatch-boards'

/**
 * 表示中の配車板の取得クエリ。板を描画しているコンテナだけが書き込み、
 * 保存系の再取得・invalidate・キャッシュ読み出しはここを読む。
 *
 * 板クエリのキャッシュキーはこのクエリそのもの（tenantKey + dcId + 期間 +
 * daysToFetch）で、daysToFetch は表示モードでクランプが変わる
 * （resolveBoardApiDaysToFetch）。呼び出し側が個別にキーを組み直すと実キャッシュと
 * ずれ、再取得が空振りする・存在しないキーで無駄な取得が走る。単一の書き手が
 * 実際に使ったクエリを配ることでズレようがなくする。
 *
 * 板が描画されていない間は null。
 */
export const activeBoardQueryAtom =
  atom<FetchVehicleDispatchBoardsQuery | null>(null)

activeBoardQueryAtom.debugLabel = 'activeBoardQueryAtom'
